import { z } from "zod";
import { UK_FILTER_SCHEMA } from "../../search/filters/site-sourcing-filter-schema";

export const setSiteSourcingFiltersToolSchema = {
  inputSchema: z.object({
    filters: UK_FILTER_SCHEMA,
    location: z.object({
      id: z.string(),
      council_name: z.string(),
      gss_code: z.string(),
    }),
  }),
  outputSchema: z.object({
    filtersUpdated: z.boolean().describe("If the filters were updated"),
  }),
};

export type SetSiteSourcingFiltersToolInput = z.infer<typeof setSiteSourcingFiltersToolSchema.inputSchema>;
export type SetSiteSourcingFiltersToolOutput = z.infer<typeof setSiteSourcingFiltersToolSchema.outputSchema>;
